// extracted by mini-css-extract-plugin
module.exports = {"ListHeader":"UserRatingsPortalSettingList_ListHeader__1tdCd","UserListCell":"UserRatingsPortalSettingList_UserListCell__QF-Ra"};